"use client";

import { Target, Activity, Eye, ArrowRight, Layers } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Casopracticoworkflow() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const phases = [{
    step: "09:00",
    title: "INICIO",
    description: "Se inicia la excursión",
    Icon: Target
  }, {
    step: "13:15",
    title: "DETECCION",
    description: "Transmisión de datos en tiempo real detecta un retraso",
    Icon: Activity
  }, {
    step: "13:16",
    title: "UPDATE",
    description: "El sistema actualiza automáticamente los datos a los usuarios.",
    Icon: Eye
  }, {
    step: "13:20",
    title: "OPTIMIZACIÓN",
    description: "Restauración reorganiza el servicio en base a los datos recibidos.",
    Icon: ArrowRight
  }, {
    step: "14:00",
    title: "FIN",
    description: "Los huéspedes retornan a su punto de origen",
    Icon: Layers
  }];
  return <section data-section-id="5079" id="casopracticoworkflow" className="relative bg-background text-foreground py-24 md:py-40 px-4 sm:px-6 lg:px-12 overflow-hidden">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "linear-gradient(to right, var(--foreground) 1px, transparent 1px), linear-gradient(to bottom, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "80px 80px"
    }} />

      <div ref={ref} className={`relative max-w-7xl mx-auto transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="flex flex-col items-center text-center mb-16 md:mb-24">
          <div className="flex items-center gap-4 mb-8">
            <span className="h-px w-10 bg-primary" />
            <span className="font-mono text-xs tracking-[0.3em] text-primary uppercase">CASO PRACTICO</span>
            <span className="h-px w-10 bg-primary" />
          </div>

          <h2 className="font-default font-bold uppercase tracking-tight text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-foreground leading-[0.95] max-w-5xl">
            El Flujo TimeArrival.
          </h2>

          <p className="font-default text-base md:text-lg text-muted-foreground mt-8 max-w-xl leading-relaxed">Un marco operativo diseñado para digitalizar la movilidad interna de su resort y elevar la experiencia del huésped.</p>
        </div>

        {}
        <div className="hidden lg:grid grid-cols-5 gap-0 relative">
          {phases.map((phase, i) => {
          const isActive = i === 1;
          const Icon = phase.Icon;
          return <div data-index={i} key={phase.step} className="relative group px-3">
                {}
                {i < phases.length - 1 && <div aria-hidden="true" className="absolute top-1/2 -right-3 w-6 h-px z-0" style={{
              backgroundImage: "repeating-linear-gradient(to right, var(--primary) 0 4px, transparent 4px 10px)"
            }} />}

                <div className="relative backdrop-blur-sm bg-card border border-border shadow-md p-6 flex flex-col justify-between transition-all duration-300 group-hover:border-primary group-hover:-translate-y-2 group-hover:shadow-lg !h-[320px]">
                  <div>
                    <div className="font-mono text-5xl font-normal text-muted-foreground/60 leading-none">
                      {phase.step}
                    </div>
                    <div className={`h-px w-12 mt-4 mb-6 ${isActive ? "bg-primary" : "bg-border group-hover:bg-primary"} transition-colors duration-300`} />
                    <h3 className="font-default font-semibold text-xl md:text-[22px] uppercase tracking-tight text-foreground mb-4">
                      {phase.title}
                    </h3>
                    <p className="font-default text-sm leading-relaxed text-muted-foreground">
                      {phase.description}
                    </p>
                  </div>

                  <div className="flex justify-end mt-6">
                    <Icon className="size-7 text-primary" strokeWidth={1.25} />
                  </div>
                </div>
              </div>;
        })}
        </div>

        {}
        <div className="lg:hidden flex flex-col gap-0 max-w-md mx-auto">
          {phases.map((phase, i) => {
          const isActive = i === 1;
          const Icon = phase.Icon;
          return <div data-index={i} key={phase.step} className="relative">
                <div className={`relative backdrop-blur-sm bg-card border ${isActive ? "border-primary shadow-lg" : "border-border"} shadow-md p-6 flex flex-col transition-all duration-300 hover:border-primary hover:shadow-lg`}>
                  <div className="flex items-start justify-between mb-4">
                    <div className="font-mono text-4xl font-normal text-muted-foreground/60 leading-none">
                      {phase.step}
                    </div>
                    <Icon className="size-6 text-primary" strokeWidth={1.25} />
                  </div>
                  <div className={`h-px w-12 mb-4 ${isActive ? "bg-primary" : "bg-border"}`} />
                  <h3 className="font-default font-semibold text-xl uppercase tracking-tight text-foreground mb-3">
                    {phase.title}
                  </h3>
                  <p className="font-default text-sm leading-relaxed text-muted-foreground">
                    {phase.description}
                  </p>
                </div>

                {}
                {i < phases.length - 1 && <div aria-hidden="true" className="mx-auto w-px h-10" style={{
              backgroundImage: "repeating-linear-gradient(to bottom, var(--primary) 0 4px, transparent 4px 10px)"
            }} />}
              </div>;
        })}
        </div>

        <div className="font-default font-bold uppercase text-4xl sm:text-5xl leading-tight text-primary text-center mt-16 md:mt-24">
          MAYOR SATISFACCION
        </div>
      </div>
    </section>;
}